import React, { useEffect } from 'react'
import { X } from 'lucide-react'
import { cx } from '@/lib/utils'
import styles from './MobileMenuOverlay.module.scss'

interface MobileMenuOverlayProps {
  isOpen: boolean
  onClose: () => void
  closeLabel: string
  logo: React.ReactNode
  children: React.ReactNode
}

export const MobileMenuOverlay: React.FC<MobileMenuOverlayProps> = ({
  isOpen,
  onClose,
  closeLabel,
  logo,
  children,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <div
      className={cx(styles.overlay, isOpen && styles.open)}
      aria-hidden={!isOpen}
    >
      <div className={styles.header}>
        <div>{logo}</div>
        <button
          type="button"
          onClick={onClose}
          className={styles.closeButton}
          aria-label={closeLabel}
        >
          <X size={24} />
        </button>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  )
}
